module.exports = __webpack_public_path__ + "static/media/airclassifier.edc699c2.png";